import {observer} from "mobx-react";
import React from "react";
import {
    IPsoWorkerAgreementFormFields,
    IPsoWorkerAgreementViewModel
} from "../../../../services/booking/models/pso/agreements/workers/pso-worker-agreement.view-model.interface";
import {useServices} from "../../../../hooks/use-services.hook";
import {InfoLineBox} from "../common/boxes/pso-agreement.boxes";
import {PsoAgreementsComponent} from "../common/pso-agreements.component";
import {
    IPsoWorkAgreementsViewModel
} from "../../../../services/booking/models/pso/agreements/workers/pso-works-agreements.view-model.interface";


interface PsoWorkersAgreementsComponentProps{

    workersAgreements: IPsoWorkAgreementsViewModel;
}

export const PsoWorkersAgreementsComponent = observer((props: PsoWorkersAgreementsComponentProps) => {


    const services = useServices();

    const AgreementsComponent = PsoAgreementsComponent<IPsoWorkerAgreementFormFields, IPsoWorkerAgreementViewModel, IPsoWorkAgreementsViewModel>;

    const  renderHeader = () => {
        return (
            <div>
                {services.language.translationFor(`For non-resident passengers travelling to {region} for work-related reasons, it is mandatory to complete the following online form in its entirety and submit it immediately by clicking the dedicated 'Submit declaration' button.`)
                    .withParams({region: props.workersAgreements.getMarketNameTranslation()})}
            </div>
        );
    }

    return (
        <AgreementsComponent psoAgreements={props.workersAgreements} renderHeader={renderHeader}>

            <InfoLineBox>
                {services.language.translate('The form must also be printed, duly signed, and presented at the airport at the time of boarding, together with a copy of a valid identity document.')}
            </InfoLineBox>
            <InfoLineBox>
                {services.language.translate('Pursuant to Article 47 of Presidential Decree no. 445/2000, Aeroitalia SpA may carry out any documentary and operational checks deemed appropriate or necessary in order to verify the statements declared.')}
            </InfoLineBox>
            <InfoLineBox>
                {services.language.translate('In the event of a false declaration, in addition to prompt notification to the competent judicial authority, a penalty of EUR 500.00 will be applied, as well as the forfeiture of the improperly used ticket.')}
            </InfoLineBox>

        </AgreementsComponent>
    )
});